import { render } from "./PlayerDataReporting.vue?vue&type=template&id=0150aa66&scoped=true"
import script from "./PlayerDataReporting.vue?vue&type=script&lang=js"
export * from "./PlayerDataReporting.vue?vue&type=script&lang=js"

import "./PlayerDataReporting.vue?vue&type=style&index=0&id=0150aa66&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0150aa66"]])

export default __exports__